import { useState, useEffect } from "react";
import {
  IconButton,
  Popover,
  Box,
  Typography,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  CircularProgress,
  ListItemText,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import apiClient from "../../services/apiClient";
import toast from "react-hot-toast";
import { Pause, PlayArrow } from "@mui/icons-material";
import CustomInputBox from "../Form/CustomInputBox";
import { FaLink } from "react-icons/fa6";

const AgentSettingsWidget = () => {
  const agentId = "68b04fe3379ae47560e2eedb";

  const [anchorEl, setAnchorEl] = useState(null);

  const [languageData, setLanguageData] = useState([]);

  const [voiceData, setVoiceData] = useState([]);
  console.log("voiceData", voiceData);

  const [formData, setFormData] = useState({
    assigned_language_type: "en-US",
    assigned_voice_type: "",
    file: null,
    importUrl: "",
  });
  const [initialData, setInitialData] = useState({});
  const [loading, setLoading] = useState(false);
  const [playingId, setPlayingId] = useState(null);
  const [audio, setAudio] = useState(null);

  const open = Boolean(anchorEl);
  const id = open ? "settings-popover" : undefined;

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const fetchVoice = async () => {
    try {
      const response = await apiClient.get("/voice-codes");
      console.log(response?.data, "response?.data");
      setVoiceData(response?.data || []);
    } catch (error) {
      console.error("Voice fetch failed:", error);
    }
  };

  const fetchLanguage = async () => {
    try {
      const response = await apiClient.get("/languages");
      setLanguageData(response?.data || []);
    } catch (error) {
      console.error("Language fetch failed:", error);
    }
  };

  const fetchAgentDetails = async () => {
    try {
      const response = await apiClient.get(`/agent-details-id/${agentId}`);
      const data = response.data;

      const voiceId = data?.assigned_voice_type?.id || "";
      const languageId = data?.assigned_language_type?.id || "";
       let importUrl = "";
    let files = [];

       data?.sources?.forEach((source) => {
      if (source.type === "website") {
        importUrl = source.content;
      } else if (source.type === "file") {
        files.push(source.content);
      }
    });

      setFormData({
        assigned_language_type: languageId || "",
        assigned_voice_type: voiceId,
          importUrl,
      files,
      });
      setInitialData({
        assigned_language_type: languageId || "",
        assigned_voice_type: voiceId,
          importUrl,
      files,
      });
    } catch (error) {
      console.error("Agent details fetch failed:", error);
    }
  };

  useEffect(() => {
    fetchVoice();
    fetchLanguage();
    fetchAgentDetails();
  }, []);

  const hasChanges =
    formData.assigned_language_type !== initialData.assigned_language_type ||
    formData.assigned_voice_type !== initialData.assigned_voice_type ||
    formData.importUrl !== initialData.importUrl ||
    formData.file !== initialData.file;

  const handleChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // const payload = {
    //   ...formData,
    // };
    setLoading(true);
    try {
        const payload = new FormData();
    payload.append("assigned_language_type", formData.assigned_language_type);
    payload.append("assigned_voice_type", formData.assigned_voice_type);
    payload.append("website_url", formData.importUrl);

     if (formData.file) {
      const files = Array.isArray(formData.file)
        ? formData.file
        : [formData.file];
      files.forEach((file) => payload.append("files[]", file));
    }
      await apiClient.put(`/update-agent-details/${agentId}`, payload);
      setInitialData(formData);
      toast.success("Agent settings updated successfully");
      handleClose();
    } catch (error) {
      console.error("Error saving request:", error);
      toast.error(
        error.response.data.message || "Failed to update agent settings"
      );
    } finally {
      setLoading(false);
    }
  };

  const handlePlay = (ele) => {
    if (audio) {
      audio.pause();
      setAudio(null);
      setPlayingId(null);
    }

    if (playingId !== ele._id) {
      const newAudio = new Audio(
        `${process.env.REACT_APP_BASE_URL}/${ele.voice_sample.replace(
          /\\/g,
          "/"
        )}`
      );
      newAudio.play();
      setAudio(newAudio);
      setPlayingId(ele._id);

      newAudio.onended = () => {
        setPlayingId(null);
        setAudio(null);
      };
    }
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <SettingsIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box sx={{ p: 2, width: 350 }}>
          <Typography variant="h6" gutterBottom>
            Agent Settings
          </Typography>

          <FormControl fullWidth margin="normal">
            <InputLabel>Language</InputLabel>
            <Select
              value={formData.assigned_language_type}
              onChange={handleChange("assigned_language_type")}
              label="Language"
            >
              {languageData.map((lang) => (
                <MenuItem key={lang._id} value={lang._id}>
                  {lang.language_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth margin="normal">
            {/* <Select
              value={formData.assigned_voice_type}
              onChange={handleChange("assigned_voice_type")}
              label="Voice"
            >
              {voiceData
                .filter((voice) => voice?.language?._id === formData.assigned_language_type)
                .map((voice) => (
                  <MenuItem key={voice._id} value={voice._id}>
                    {voice.gender}
                  </MenuItem>
                ))}
            </Select> */}
            <InputLabel>Voice</InputLabel>
            <Select
              name="assigned_voice_type"
              label="Voice"
              value={formData.assigned_voice_type || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  assigned_voice_type: e.target.value,
                }))
              }
              renderValue={(selected) => {
                const voice = voiceData.find((v) => v._id === selected);
                return voice
                  ? `${voice.gender} – ${voice.voice_name}`
                  : "Choose AI Voice";
              }}
            >
              {voiceData
                .filter(
                  (ele) => ele.language._id === formData.assigned_language_type
                )
                .map((ele) => (
                  <MenuItem
                    key={ele._id}
                    value={ele._id}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <Typography variant="body1" fontWeight={500}>
                        {ele.gender} – {ele.voice_name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {ele.language.language_name}
                      </Typography>
                    </Box>
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePlay(ele);
                      }}
                    >
                      {playingId === ele._id ? <Pause /> : <PlayArrow />}
                    </IconButton>
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="normal">
             <CustomInputBox
                      placeholder=""
                      type="text"
                      required={true}
                      name="importUrl"
                      
                      borderRadius="4px"
                      margin={"20px 0px"}
                      backgroundColor={"white"}
                      variant="outlined"
                      label="Website URL"
                      value={formData.importUrl || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    importUrl: e.target.value,
                  }))
                }
                    />
           
          </FormControl>

          {/* Choose File */}
          <FormControl fullWidth margin="normal">
             <CustomInputBox
                      placeholder=""
                      type="file"
                      required={true}
                      name="file"
                       height= "45px" 
                      borderRadius="4px"
                      margin={"15px 0px"}
                      backgroundColor={"white"}
                      variant="outlined"
                      label="Choose File"
                     
               onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    file: e.target.files[0],
                  }))
                }
                    />


                     {Array.isArray(formData.files) && formData.files.length > 0 && (
    <Box mt={1}>
      {formData.files.map((f, i) => (
        <Typography
          key={i}
          variant="body2"
          color="text.secondary"
          sx={{ wordBreak: "break-all" }}
        >
          <FaLink/> Existing file:{" "}
          <a
            href={`${process.env.REACT_APP_BASE_URL}/${f}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {f.split("/").pop()}
          </a>
        </Typography>
      ))}
    </Box>
  )}
           
          </FormControl>

          <Box mt={2} textAlign="right">
            <Button
              variant="contained"
              disabled={!hasChanges || loading}
              onClick={handleSubmit}
            >
              {loading ? <CircularProgress size={24} /> : "Save"}
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default AgentSettingsWidget;
